import { Text } from '@chakra-ui/react';
import React from 'react';
import { IconType } from 'react-icons';

import {
  EventForRenderFragmentGQLType,
  VerificationActionKeyGQLType,
} from 'types/dashboard-core-gqlTypes.generated';

import { getVerificationPayloadWithAssert } from 'packages/common-frontend/utils';
import { FiCheck, FiX } from 'react-icons/fi';

const verification: {
  [key in VerificationActionKeyGQLType]: {
    Component: ({
      event,
    }: {
      event: EventForRenderFragmentGQLType;
    }) => React.ReactElement;
    icon: IconType;
    PanelComponent?: ({
      event,
    }: {
      event: EventForRenderFragmentGQLType;
    }) => React.ReactElement;
  };
} = {
  verificationReportApproved: {
    Component: function InsertDeliverableItemComponent({
      event,
    }: {
      event: EventForRenderFragmentGQLType;
    }) {
      const { actorName } = event;
      const payload = getVerificationPayloadWithAssert(event);
      const { creditFacilityName } = payload;
      return (
        <Text>
          <strong>{`${actorName} approved`}</strong>
          {` a verification report for `}
          <strong>{creditFacilityName}</strong>
        </Text>
      );
    },
    icon: FiCheck,
  },
  verificationReportRejected: {
    Component: function InsertDeliverableItemComponent({
      event,
    }: {
      event: EventForRenderFragmentGQLType;
    }) {
      const { actorName } = event;
      const payload = getVerificationPayloadWithAssert(event);
      const { creditFacilityName } = payload;
      return (
        <Text>
          <strong>{`${actorName} rejected`}</strong>
          {` a verification report for `}
          <strong>{creditFacilityName}</strong>
        </Text>
      );
    },
    icon: FiX,
  },
};

export default verification;
